import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e09d216"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Create a supervised user account for this profile? ", -1))
const _hoisted_2 = { class: "details" }

import { computed, ref } from 'vue'
import { useUserStore } from '@/gp/UserStore'
import Modal from '@/util/Modal.vue'
import ProfileCard from '@/manage/ProfileCard.vue'
import { useDataGroupStore } from '@/gp/DataGroupStore';



export default /*#__PURE__*/_defineComponent({
  __name: 'UserAddModal',
  setup(__props, { expose: __expose }) {

const profileGroupIdRef = ref<string>()
const modalRef = ref<InstanceType<typeof Modal>>()

const userStore = useUserStore()
const dataGroupStore = useDataGroupStore()

const profilePersonIdRef = computed(() => dataGroupStore.getLoadedGroup(profileGroupIdRef.value)?.startItemId)

__expose({
  open
})

function open(profileGroupId: string) {
  profileGroupIdRef.value = profileGroupId
  modalRef.value?.open()  
}

async function addUser() {
  const newUserId = await userStore.addForProfileAsync(profileGroupIdRef.value!)
  modalRef.value?.close()
}

function onNavigate() {
  modalRef.value?.close()
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    class: "user-add-modal",
    onOk: addUser
  }, {
    title: _withCtx(() => [
      _createTextVNode("Create child account")
    ]),
    okText: _withCtx(() => [
      _createTextVNode("Create account")
    ]),
    busyText: _withCtx(() => [
      _createTextVNode("Creating...")
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(ProfileCard, {
        "person-id": profilePersonIdRef.value,
        static: ""
      }, null, 8, ["person-id"]),
      _createElementVNode("p", _hoisted_2, [
        _createTextVNode(" You will be the initial account supervisor and will be able to manage all aspects of the account. You can add other supervisors once the account is created. The supervised user will have limits on what they can do. "),
        _createVNode(_component_router_link, {
          to: "/learn/supervised-users",
          onClick: onNavigate
        }, {
          default: _withCtx(() => [
            _createTextVNode("Learn more")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 512))
}
}

})